import { Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { CalendarBackEndPair } from '../../todo/calendar-view/calendar-view';
import { Appointment, CommonService, Config, ChecklistTemplate, ChecklistTemplateItem, TeamMember, FamilyEntity, ServiceLevelServices, Service, SchedulingStateModel, GetServiceLevelsForTeamIds, ChecklistItem , GetAppointments} from 'huddyapi';

import moment_ from 'moment';

import { MatTable } from "@angular/material/table";

import { Observable, Subscription, timer } from 'rxjs';

import { FamilyAppointmentsComponent } from '../family-appointments/family-appointments.component';
import { EditCalendarEventDialog } from '../../components/edit-calendar-event-dialog/edit-calendar-event-dialog.component';
import { CommunityConfigService } from '../../services/community-config.service';





const moment = moment_;

@Component({
  selector: 'family-checklist-view',
  templateUrl: './family-checklist-view.component.html',
  styleUrls: ['./family-checklist-view.component.scss']
})
export class FamilyChecklistView
  {

  @Input() appointments : Appointment[];
  @Input() user : string;
  @Input() checklistTemplates : ChecklistTemplate[];
  @Input() family : FamilyEntity;


  currentTeamMembers : TeamMember[];


  currentServiceLevels : ServiceLevelServices[];
  @Select(state => state.schedulingState) schedulingState$: Observable<SchedulingStateModel>;
  @ViewChild(MatTable) table: MatTable<any>;

  schedulingSubscription : Subscription;

  displayColumns : string[] = ['name',  'sequenceNum', 'startDateTime', 'status','workerScore', 'managerScore', 'workerNotes', 'managerNotes'];

  checklistRows : ChecklistRow[];
  constructor(
    private store : Store,
    private config: Config,
    private commonService : CommonService,
    public router: Router,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer
  ) {
    this.currentTeamMembers = CommunityConfigService.allMembers;
    this.store.dispatch(new GetServiceLevelsForTeamIds(CommunityConfigService.fullTeams.map(pg => pg.id)));
  }

  ngOnInit() {


    console.log('checklistRows', this.checklistRows);
    this.schedulingSubscription = this.schedulingState$.subscribe((schedulingState : SchedulingStateModel) => {
      if ( schedulingState.serviceLevelServices && schedulingState.serviceLevelServices.length > 0 && !this.currentServiceLevels) {
      this.currentServiceLevels =  schedulingState.serviceLevelServices;
      console.log('setting currentServiceLevels', this.currentServiceLevels);
      this.rebuildRows();
      }
    });
  }
  getMatchingChecklistItems(checklistTemplate : ChecklistTemplate, item : ChecklistTemplateItem) {
    if (!this.appointments) {
      return [];
    }
    return this.appointments
      .filter(a => a.checklist && a.checklist.sourceTemplateIds.indexOf(checklistTemplate.id) > -1)
      .sort((a, b) => a.sequenceNum - b.sequenceNum);
  }

  rebuildRows() {
    this.checklistRows = this.buildChecklistRows();
    if (this.table) {
      console.log('table is rendering 1');
      this.table.renderRows();
    } else {
      console.log('table is undefined');
    }
  }

  buildChecklistRows() : ChecklistRow[] {
    let ret : ChecklistRow[] = [];
    let serviceLevelServices : ServiceLevelServices = this.currentServiceLevels.find(sl => sl.serviceLevel.id === this.family.serviceLevelId);
    for (let ct of this.checklistTemplates) {
      ret.push({
        type: 'TEMPLATE',
        name : ct.name
      });
      for (let cti of ct.items) {
        ret.push({
          type: 'ITEM',
          name : cti.item
        });
        console.log('cti', cti);
        let service : Service = serviceLevelServices.serviceLevel.services.find(svc => svc.id === cti.serviceId);
        console.log('buildChecklistRows service', cti.serviceId, service, serviceLevelServices, this.currentServiceLevels);
        for (let a of this.getMatchingChecklistItems(ct, cti)) {
          let ci : ChecklistItem = a.checklist.checklistItems.find(item => item.item === cti.item);
          ret.push({
            type: 'APPOINTMENT',
            appointmentId: a.id,
            name :  a.description,
            status : a.status.toLowerCase().split('_').map((word: any) => {
              return (word.charAt(0).toUpperCase() + word.slice(1));
            }).join(' '),
            startDateTime : FamilyAppointmentsComponent.getDateFromTimestamp(a.startDateTime),
            service : service ? service.name : '',
            workerScore : ci.workerScore,
            managerScore : ci.managerScore,
            workerNotes : ci.workerNotes,
            managerNotes : ci.managerNotes,
            isLate : a.isLate,
            sequenceNum : a.sequenceNum
          });
        }
      }
    }

    return ret;
  }

  isAppointmentLate(row : ChecklistRow) {
    const appointment = this.appointments.find(app => app.id === row.appointmentId);
    if (!appointment) {
      return false;
    }
    return appointment.isLate ||
    (FamilyAppointmentsComponent.COMPLETED.indexOf(appointment.status) > -1 && row.workerScore < 10 && row.requiredBy <= appointment.sequenceNum);
  }

  onRowSelect(row : ChecklistRow) {
    if (row.type === 'APPOINTMENT') {
      const appointment : Appointment = this.appointments.find(a => a.id === row.appointmentId);
      if (appointment) {
        this.edit(row, appointment);
      }
    }
  }




  edit(row : ChecklistRow, a? :Appointment) {

    let pair : CalendarBackEndPair;
    let appointment : Appointment;
    if (row || a) {
      appointment = a ? a : this.appointments.find(a => a.id === row.appointmentId);
      pair = {
        action: 'Edit',
        username : this.user,
        checklistTemplates : this.checklistTemplates,
        calendarEvent : undefined,
        backendEvent : {
          id: appointment.id,
          start: new Date(FamilyAppointmentsComponent.getDateFromTimestamp(appointment.startDateTime)),
          end: new Date(FamilyAppointmentsComponent.getDateFromTimestamp(appointment.endDateTime)),
          text: appointment.description,
          checklistId : (appointment.checklist) ? appointment.checklist.id : undefined,
          sourceType : 'Appointment',
          status : appointment.status,
          teamId : undefined,
          teamMembers: appointment.teamMembers,
          appointmentType: appointment.appointmentType
        }
      };
    } else {
      pair = {
        action: 'Requested',
        calendarEvent: undefined,
        backendEvent: undefined,
        username : this.user,
        checklistTemplates : this.checklistTemplates
      }
    }

      console.log('edit', pair, this.currentServiceLevels);
      const height: string = '575px';
      const dialog = this.dialog.open(EditCalendarEventDialog, {
        width: '600px',
        height: height,
        data: {
          pair: pair,
          currentTeam : undefined,
          currentMembers : this.currentTeamMembers,
          appointment : appointment,
          serviceLevels : this.currentServiceLevels
        }
    });
    dialog.afterClosed().subscribe(t => {
      timer(1500).subscribe(fire => {
        this.store.dispatch(new GetAppointments(this.family.id)).subscribe(t=> {
          this.rebuildRows()
        });
      });
    });

  }

}

export interface ChecklistRow {
  appointmentId? : number;
  type : string;
  name : string;
  startDateTime? : number;
  status? : string;
  service? : string;
  requiredBy? : number;
  workerScore? : number;
  managerScore? : number;
  workerNotes? : string;
  managerNotes? : string;
  isLate? : boolean;
  sequenceNum? : number
}
